import CollectionContainer from '../containers/Collection';
const startCollection = () => {
    console.log('UNTUCKit : Template : CollectionTemplate');
    new CollectionContainer();
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCollection, { once: true });
}
else {
    startCollection();
}
